import React from "react";

// Barefoot footprint (sole + five toes). Same 12x14 box as the previous icon
// so the hero-banner layout is untouched; drawn as simple ellipses so the
// shape stays readable at 12px.
const Foot = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="white">
        {/* toes, big toe on the inner (left) side */}
        <circle cx="1.7" cy="2.6" r="1.25" />
        <circle cx="4.5" cy="1.4" r="1.05" />
        <circle cx="7.0" cy="1.1" r="0.95" />
        <circle cx="9.2" cy="1.6" r="0.85" />
        <circle cx="10.9" cy="2.7" r="0.75" />
        {/* main pad */}
        <ellipse cx="5.6" cy="6.6" rx="3.6" ry="3.4" />
        {/* arch + heel */}
        <path d="M3.4 8.6 C3.1 10.2 3.6 11.2 4.6 12.1 C5.5 12.9 7.2 13.2 8.1 12.4 C9.1 11.5 9.0 10.0 8.6 8.6 C7.9 9.6 4.9 9.7 3.4 8.6 Z" />
      </g>
    </svg>
  );
};

export default Foot;
